import { NavItem } from './nav-item/nav-item';

/** Limited sidebar for Sales role: create/list orders + linked retailers. */
export const salesItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'aperture',
    route: '/dashboard',
  },
  {
    displayName: 'Orders',
    iconName: 'shopping-cart',
    route: 'apps/orders',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/orders/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/orders/list',
      },
      {
        displayName: 'Awaiting driver',
        iconName: 'point',
        route: 'apps/orders/awaiting-driver',
      },
    ],
  },
  {
    displayName: 'Retailers',
    iconName: 'user-shield',
    route: 'apps/retailers',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/retailers/list',
      },
    ],
  },
];
